var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.689 17.166l-2.886-2.886a5.762 5.762 0 0 0 1.043-3.357c0-.802-.155-1.569-.467-2.3a5.92 5.92 0 0 0-1.262-1.894 5.92 5.92 0 0 0-1.893-1.262 5.821 5.821 0 0 0-2.3-.467 5.82 5.82 0 0 0-2.302.467A5.92 5.92 0 0 0 6.73 6.729c-.53.53-.95 1.161-1.262 1.893A5.82 5.82 0 0 0 5 10.923c0 .802.156 1.569.467 2.301a5.923 5.923 0 0 0 1.262 1.893c.53.53 1.161.95 1.893 1.262a5.82 5.82 0 0 0 2.301.467 5.762 5.762 0 0 0 3.357-1.043l2.886 2.877a1 1 0 0 0 .757.32c.298 0 .551-.105.762-.316.21-.21.315-.464.315-.761s-.104-.55-.311-.757zm-5.103-3.58c-.738.737-1.625 1.106-2.663 1.106-1.037 0-1.925-.369-2.663-1.106-.737-.738-1.106-1.625-1.106-2.663 0-1.038.369-1.925 1.106-2.663.738-.737 1.626-1.106 2.663-1.106 1.038 0 1.925.369 2.663 1.106.738.738 1.107 1.625 1.107 2.663 0 1.038-.37 1.925-1.107 2.663z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.347 10.384h-1.885V8.5a.259.259 0 0 0-.08-.19.259.259 0 0 0-.19-.08h-.537a.259.259 0 0 0-.19.08.259.259 0 0 0-.08.19v1.884H8.501a.259.259 0 0 0-.19.08.259.259 0 0 0-.08.19v.538c0 .073.027.136.08.19.054.053.117.08.19.08h1.884v1.884c0 .073.027.136.08.19.053.053.117.08.19.08h.538a.259.259 0 0 0 .19-.08.259.259 0 0 0 .08-.19v-1.885h1.884a.26.26 0 0 0 .19-.08.259.259 0 0 0 .079-.189v-.538a.26.26 0 0 0-.08-.19.259.259 0 0 0-.19-.08z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsZoom);
export default __webpack_public_path__ + "static/media/Icons_Zoom.baea76050f9667fdf71e936668f7b4de.svg";
export { ForwardRef as ReactComponent };